import { useMutation } from 'react-query';
import { LocalStorageKey } from 'src/localStorage/enums/localStorageKey.enum';
import { getDataFromLocalStorage } from 'src/localStorage/getDataFromLocalStorage';
import { useNotification } from 'src/providers/notificationsProvider';
import { getClient } from 'src/util/mdello-instance';

const addComment = async ({ id, text }: { id: string; text: string }) => {
  const currentProject: any = getDataFromLocalStorage(LocalStorageKey.CURRENT_PROJECT);
  if (!currentProject) return;

  await getClient()?.addActionComment(currentProject?._id, id, { text });
};

export const useAddComment = ({ onSuccess }: { onSuccess?: () => void }) => {
  const { notify } = useNotification();

  return useMutation(addComment, {
    onError: () => {
      notify({ message: 'something went wrong', severity: 'error' });
    },
    onSuccess: () => {
      if (onSuccess) {
        onSuccess();
      }
    }
  });
};
